const SYSTEM_USER = "SYSTEM";

const SYS_ADMIN = "SYS_ADMIN";
const SYS_SUPERVISOR = "SYS_SUPERVISOR";
const SYS_BO = "SYS_BO";
const ADMIN = "ADMIN";
const SECURITY = "SECURITY";
const API = "API";
const USER = "USER";

const ROLES = {
  SYS_ADMIN,
  SYS_BO,
  SYS_SUPERVISOR,
  ADMIN,
  USER,
  SECURITY,
  API,
  COMPANY_SUPERVISOR_ROLES: [ADMIN, USER],
  ALL_SYS_ROLES: [SYS_ADMIN, SYS_SUPERVISOR, SYS_BO],
  ONLY_ADMINS: [SYS_ADMIN, ADMIN]
};

const BOT_PARTY = "BoT-Party";
const HEADERS = { BOT_PARTY };
const DATE_FORMAT_DD_MM_YYYY = "DD/MM/YYYY";
const OPERATIONS = {
  ADD: "ADD",
  UPDATE: "UPDATE",
  REMOVE: "REMOVE"
};
const OBLIGATIONS = {
  TYPES: {
    VEHICLE_OBLIGATION: "vehicle_obligation",
    OBLIGATION: "contractor_obligation",
    EMPLOYEES_OBLIGATION: "employee_obligation"
  },
  DUEDATE_TYPES: {
    MONTHLY_DUEDATE_TYPE: "monthly",
    BIMONTHLY_DUEDATE_TYPE: "bimonthly",
    QUARTERLY_DUEDATE_TYPE: "quarterly",
    BIANNUAL_DUEDATE_TYPE: "biannual",
    ANNUAL_DUEDATE_TYPE: "annual",
    ONCE_DUEDATE_TYPE: "once",
    DATE_LIMIT_DUEDATE_TYPE: "date_limit"
  },
  ACTIONS: {
    APPROVE_ACTION: "approve",
    CANCEL_ACTION: "cancel"
  },
  STATUS: {
    MISSING_DATE_STATUS: "missing_date",
    DELAYED_STATUS: "delayed",
    DELIVERED_STATUS: "delivered",
    NOT_DELIVERED_STATUS: "not_delivered",
    APPROVAL_PENDING_STATUS: "approval_pending",
    APPROVAL_CANCELLED_STATUS: "cancelled",
    EXCLUDED_STATUS: "excluded",
    DELAYES_NEXT_MONTH_STATUS: "delayes_next_month"
  }
};
const IDENTIFIERS = {
  DNI: "dni",
  CUIT: "cuit",
  CUIL: "cuil"
};
const VISIT = {
  authorized: "authorized",
  pending_authorization: "pending_authorization",
  active: "active",
  rejected: "rejected",
  finished: "finished",
  cancelled: "cancelled",
  pending_rate: "pending_rate"
};

const VISITOR_STATE = {
  entered: "entered",
  left: "left",
  reentered: "reentered"
};

const VISITOR_TYPE = {
  vehicle: "vehicle",
  employee: "employee"
};

const PERSONAL_PROTECTION_ITEMS = ["helmet", "securityShoes", "gloves", "goggles", "auditoryProtector", "gasMask", "uniform", "reflectiveVest", "safetyHarness", "weldingMask" ]

const PERSONAL_PROTECTION_ITEMS_PLACEHOLDER = {
  helmet: false,
  securityShoes: false,
  gloves: false,
  goggles: false,
  auditoryProtector: false,
  gasMask: false,
  uniform: false,
  reflectiveVest: false,
  safetyHarness: false,
  weldingMask: false,
  verify: false
};

export default {
  SYSTEM_USER,
  ROLES,
  HEADERS,
  OBLIGATIONS,
  IDENTIFIERS,
  DATE_FORMAT_DD_MM_YYYY,
  OPERATIONS,
  VISIT,
  VISITOR_STATE,
  VISITOR_TYPE,
  PERSONAL_PROTECTION_ITEMS,
  PERSONAL_PROTECTION_ITEMS_PLACEHOLDER
};
